import { useContext, useEffect, useState } from 'react';
import { Grid, Card, CardContent, CardHeader } from '@material-ui/core';
import { Select, FieldError } from '../../../../common';
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';
import { SettingsContext } from '../../../../contexts/SettingsContext';
import { SapTableNames } from '../../../../../helpers';

export const AccountReceivableForm = (props) => {
    const {
        state,
        getTableOptionsWithCode,
        getReconciliationAccountOptions,
        getAccountingClerksOptions
    } = useContext(CustomerRequestContext)

    const {
        values
    } = useContext(TabsContext);

    const {
        appSettingsECC,
        appSettingsS4
    } = useContext(SettingsContext);

    const [isPerfume, setIsPerfume] = useState(false);
    
    useEffect(() => {
        if (values !== null && appSettingsECC !== null) {
            const perfumeBC = appSettingsECC.find(x => x.appSettingKey === "PerfumesBusinessCategoryId");

            if (perfumeBC && Number(perfumeBC.value) === values.businessCategoryId)
                setIsPerfume(true);
        }
    }, [values, appSettingsECC]);

    useEffect(() => {
        if (values !== null && appSettingsS4 !== null) {
            const perfumeBC = appSettingsS4.find(x => x.appSettingKey === "PerfumesBusinessCategoryId");

            if (perfumeBC && Number(perfumeBC.value) === values.businessCategoryId)
                setIsPerfume(true);
        }
    }, [values, appSettingsS4]);

    return (
        <Card>
            <CardHeader title="Account Receivable Form" />
            <CardContent>
                <Grid container spacing={3}>
                    {
                        !isPerfume &&
                        <Grid item xl={6} md={12} xs={12}>
                            <Select
                                name="logisticPlanning.cG4Id"
                                label="CG4 *"
                                disabled={props.disabled}
                                options={getTableOptionsWithCode(SapTableNames.CG4, values.dbType)}
                            />
                            <FieldError name="logisticPlanning.CG4Id" errors={state.errors} />
                        </Grid>
                    }
                    <Grid item xl={6} md={12} xs={12}>
                        <Select
                            name="accountReceivable.accountAssignmentGroupId"
                            label="Account assignment group *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.AccountAssignmentGroup, values.dbType)}
                        />
                        <FieldError name="accountReceivable.accountAssignmentGroupId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Select
                            name="accountReceivable.cashManagementGroupId"
                            label="Cash management group *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.CashManagementGroups, values.dbType)}
                        />
                        <FieldError name="accountReceivable.cashManagementGroupId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Select
                            name="accountReceivable.reconcilationAccountId"
                            label="Reconciliation account *"
                            disabled={props.disabled}
                            options={getReconciliationAccountOptions()}
                        />
                        <FieldError name="accountReceivable.reconcilationAccountId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Select
                            name="accountReceivable.sortKeyId"
                            label="Sort key *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.SortKeys, values.dbType)}
                        />
                        <FieldError name="accountReceivable.sortKeyId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="accountReceivable.accountingClerkId"
                            label="Accounting clerk"
                            disabled={props.disabled}
                            options={getAccountingClerksOptions()}
                        />
                        <FieldError name="accountReceivable.accountingClerkId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="accountReceivable.dunningProcedureId"
                            label="Dunning procedure"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.DunningProcedures, values.dbType, null, true)}
                        />
                        <FieldError name="accountReceivable.dunningProcedureId" errors={state.errors} />
                    </Grid>
                    {/* <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="accountReceivable.deliveringPlantId"
                            label="Delivering plant"
                            disabled={props.disabled}
                            options={getDeliveringPlantsOptions()}
                            />
                        <FieldError name="accountReceivable.deliveringPlantId" errors={state.errors} />                        
                    </Grid> */}
                </Grid>
            </CardContent>
        </Card>
    );
}